import { render, staticRenderFns } from "./horizontal-tip.vue?vue&type=template&id=f32dd1bc&scoped=true"
import script from "./horizontal-tip.vue?vue&type=script&lang=js"
export * from "./horizontal-tip.vue?vue&type=script&lang=js"
import style0 from "./horizontal-tip.vue?vue&type=style&index=0&id=f32dd1bc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32dd1bc",
  null
  
)

export default component.exports